import { useCallback, useEffect, useRef, useState } from "react";
import { getCyclesService } from "modules/monitoreo/services/crearCiclo";

export const useTableCycles = () => {
  const [cycles, setCycles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const pending = useRef(null);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const loadCycles = useCallback(async () => {
    if (pending.current) return pending.current;
    setLoading(true);
    setError(null);
    pending.current = (async () => {
      try {
        const result = await getCyclesService();
        if (!result.success) throw new Error(result.error);
        if (mounted.current) {
          setCycles([...result.data].sort((a, b) => Number(b.id) - Number(a.id)));
          setLastUpdated(new Date().toISOString());
        }
      } catch (error) {
        if (mounted.current) setError(error.message);
      } finally {
        pending.current = null;
        if (mounted.current) setLoading(false);
      }
    })();
    return pending.current;
  }, []);
  return { cycles, loading, error, lastUpdated, loadCycles };
};
